import * as React from "react";
import Observable from "./Observable";
var reject = function () { return Promise.reject("No authentication context configured"); };
var dummy = function () { return null; };
var dummyPromise = function () { return Promise.resolve(); };
var noStatus = {
    impersonating: false,
    isAdmin: false,
    isGuest: false,
    isRegistered: false,
    loggedIn: false,
    rememberMe: false,
    userInfo: null,
};
var defaultAuthContext = {
    client: {
        ChangeEmail: reject,
        ChangePassword: reject,
        ChangeGuestEmail: reject,
        CheckRegistered: reject,
        Dispose: dummy,
        EnsureGuest: reject,
        GetAccessToken: dummy,
        GetPendingOperations: function () { return 0; },
        GetStatus: function () { return noStatus; },
        Impersonate: reject,
        ImpersonateQuit: reject,
        Login: reject,
        Logout: dummyPromise,
        ResetPassword: reject,
        ResetPasswordRequest: reject,
        SaveCookieRedirect: reject,
        Status: new Observable(),
        TryAutoLogin: dummyPromise,
        UpdateToken: dummyPromise,
        UpgradeGuest: reject,
        UpgradeGuestForOrder: reject,
    },
    status: noStatus,
};
export var AuthContext = React.createContext(defaultAuthContext);
export default AuthContext;
